import React, { useState, useEffect, } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
// import "./invoice.css";

function Print() {

  const params = useParams();

  const id = params.id;

  const [dateInvoice, setDateInvoice] = useState();

  const [sale, setSale] = useState(
    {
      subtotal: 0,
      gstamount: 0,
      billamount: 0,
      name: "",
      mobile: "",
      products: [
        {
          productid: 0,
          name: "",
          price: 0,
          quantity: 0,
          subtotal: 0,
          gstpercent: 0,
          gstamount: 0,
          total: 0
        }
      ],
      "id": "1"
    }
  );



  useEffect(() => {

    axios.get(`https://653cb488d5d6790f5ec82dfd.mockapi.io/api/v1/sales/${id}`)
      .then((res) => {
        setSale(res.data);
        // console.log(res.data);
      })

    const date = new Date();
    const dateReadable = date.toLocaleDateString();
    setDateInvoice(dateReadable); //


  }, []);

  function printInvoice(e) {
    let printContent = document.getElementById('printDiv').innerHTML;
    let originalContent = document.body.innerHTML;
    console.log("printcontent:" + printContent);
    console.log("original content: " + originalContent);

    document.body.innerHTML = printContent;

    window.print();
    document.body.innerHTML = originalContent;


  }

  return (
    <div>

      <div>
        <div id='printDiv' style={{ position: "relative", boxSizing: "borderBox", height: "11in", margin: "0 auto", overflow: "hidden", padding: "0.5in", width: "8.5in", background: "#FFF", borderRadius: "1px", boxShadow: "0 0 1in -0.25in rgba(0, 0, 0, 0.5)" }}>

          <header style={{ margin: "0 0 3em", textAlign: "center" }}>
            <h1 style={{ background: "#000", borderRadius: "0.25em", color: "#FFF", margin: "0 0 1em", padding: "0.5em 0" }}>Invoice</h1>


          </header>
          <article style={{ margin: "0 0 3em" }}>
            <h1 style={{ clip: "rect(0 0 0 0)", position: "absolute" }}>Recipient</h1>
            <div className='my-invoiceAgentDetails' style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }} >
              <table className="meta" style={{ margin: "0 0 3em", float: "left", width: "36%", fontSize: "75%", tableLayout: "fixed", width: "100%", borderCollapse: "separate", borderSpacing: "2px", float: "right", width: "36%" }}
              >
                <tr>
                  <th style={{ borderWidth: "1px", padding: "0.5em", position: "relative", textAlign: "left", borderRadius: "0.25em", borderStyle: "solid", background: "#EEE", borderColor: "#BBB" }}  ><span style={{ borderRadius: "0.25em", minWidth: "1em", outline: "0", display: "inline-block" }} contenteditable>Name</span></th>
                  <td style={{ borderWidth: "1px", padding: "0.5em", position: "relative", textAlign: "right", borderRadius: "0.25em", borderStyle: "solid", borderColor: "#DDD" }}><span style={{ borderRadius: "0.25em", minWidth: "1em", outline: "0", display: "inline-block" }} contenteditable>{sale.name}</span></td>
                </tr>
                <tr>
                  <th style={{ borderWidth: "1px", padding: "0.5em", position: "relative", textAlign: "left", borderRadius: "0.25em", borderStyle: "solid", background: "#EEE", borderColor: "#BBB" }}><span style={{ borderRadius: "0.25em", minWidth: "1em", outline: "0", display: "inline-block" }} contenteditable>Mobile</span></th>
                  <td style={{ borderWidth: "1px", padding: "0.5em", position: "relative", textAlign: "right", borderRadius: "0.25em", borderStyle: "solid", borderColor: "#DDD" }}><span style={{ borderRadius: "0.25em", minWidth: "1em", outline: "0", display: "inline-block" }} contenteditable>{sale.mobile}</span></td>
                </tr>

              </table>
              <table className="meta" style={{ margin: "0 0 3em", float: "right", width: "36%", fontSize: "75%", tableLayout: "fixed", width: "100%", borderCollapse: "separate", borderSpacing: "2px", float: "right", width: "36%" }}
              >
                <tr>
                  <th style={{ borderWidth: "1px", padding: "0.5em", position: "relative", textAlign: "left", borderRadius: "0.25em", borderStyle: "solid", background: "#EEE", borderColor: "#BBB" }}  ><span style={{ borderRadius: "0.25em", minWidth: "1em", outline: "0", display: "inline-block" }} contenteditable>Invoice #</span></th>
                  <td style={{ borderWidth: "1px", padding: "0.5em", position: "relative", textAlign: "right", borderRadius: "0.25em", borderStyle: "solid", borderColor: "#DDD" }}><span style={{ borderRadius: "0.25em", minWidth: "1em", outline: "0", display: "inline-block" }} contenteditable>100{sale.id}</span></td>
                </tr>
                <tr>
                  <th style={{ borderWidth: "1px", padding: "0.5em", position: "relative", textAlign: "left", borderRadius: "0.25em", borderStyle: "solid", background: "#EEE", borderColor: "#BBB" }}><span style={{ borderRadius: "0.25em", minWidth: "1em", outline: "0", display: "inline-block" }} contenteditable>Date</span></th>
                  <td style={{ borderWidth: "1px", padding: "0.5em", position: "relative", textAlign: "right", borderRadius: "0.25em", borderStyle: "solid", borderColor: "#DDD" }}><span style={{ borderRadius: "0.25em", minWidth: "1em", outline: "0", display: "inline-block" }} contenteditable>{dateInvoice}</span></td>
                </tr>

              </table>

            </div>

            <table className="inventory" style={{ margin: "0 0 3em", float: "right", width: "36%", fontSize: "75%", tableLayout: "fixed", width: "100%" }}>
              <thead>
                <tr>
                  <th style={{ borderWidth: "1px", padding: "0.5em", position: "relative", textAlign: "center", borderRadius: "0.25em", borderStyle: "solid", background: "#EEE", borderColor: "#BBB" }}  ><span style={{ borderRadius: "0.25em", minWidth: "1em", outline: "0", display: "inline-block" }} contenteditable>No</span></th>
                  <th style={{ borderWidth: "1px", padding: "0.5em", position: "relative", textAlign: "center", borderRadius: "0.25em", borderStyle: "solid", background: "#EEE", borderColor: "#BBB" }}  ><span style={{ borderRadius: "0.25em", minWidth: "1em", outline: "0", display: "inline-block" }} contenteditable>Product</span></th>
                  <th style={{ borderWidth: "1px", padding: "0.5em", position: "relative", textAlign: "center", borderRadius: "0.25em", borderStyle: "solid", background: "#EEE", borderColor: "#BBB" }}  ><span style={{ borderRadius: "0.25em", minWidth: "1em", outline: "0", display: "inline-block" }} contenteditable>Price</span></th>
                  <th style={{ borderWidth: "1px", padding: "0.5em", position: "relative", textAlign: "center", borderRadius: "0.25em", borderStyle: "solid", background: "#EEE", borderColor: "#BBB" }}  ><span style={{ borderRadius: "0.25em", minWidth: "1em", outline: "0", display: "inline-block" }} contenteditable>Quantity</span></th>
                  <th style={{ borderWidth: "1px", padding: "0.5em", position: "relative", textAlign: "center", borderRadius: "0.25em", borderStyle: "solid", background: "#EEE", borderColor: "#BBB" }}  ><span style={{ borderRadius: "0.25em", minWidth: "1em", outline: "0", display: "inline-block" }} contenteditable>Subtotal</span></th>
                  <th style={{ borderWidth: "1px", padding: "0.5em", position: "relative", textAlign: "center", borderRadius: "0.25em", borderStyle: "solid", background: "#EEE", borderColor: "#BBB" }}  ><span style={{ borderRadius: "0.25em", minWidth: "1em", outline: "0", display: "inline-block" }} contenteditable>GST total</span></th>
                  <th style={{ borderWidth: "1px", padding: "0.5em", position: "relative", textAlign: "center", borderRadius: "0.25em", borderStyle: "solid", background: "#EEE", borderColor: "#BBB" }}  ><span style={{ borderRadius: "0.25em", minWidth: "1em", outline: "0", display: "inline-block" }} contenteditable>Total</span></th>
                </tr>
              </thead>
              <tbody>
                {sale.products.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td style={{ borderWidth: "1px", padding: "0.5em", position: "relative", textAlign: "center", borderRadius: "0.25em", borderStyle: "solid", borderColor: "#DDD" }}><span style={{ borderRadius: "0.25em", minWidth: "1em", outline: "0", display: "inline-block" }} contenteditable>{index + 1}</span></td>
                      <td style={{ borderWidth: "1px", padding: "0.5em", position: "relative", textAlign: "center", borderRadius: "0.25em", borderStyle: "solid", borderColor: "#DDD" }}><span style={{ borderRadius: "0.25em", minWidth: "1em", outline: "0", display: "inline-block" }} contenteditable>{item.name}</span></td>
                      <td style={{ borderWidth: "1px", padding: "0.5em", position: "relative", textAlign: "right", borderRadius: "0.25em", borderStyle: "solid", borderColor: "#DDD" }}><span data-prefix>Rs </span><span style={{ borderRadius: "0.25em", minWidth: "1em", outline: "0", display: "inline-block" }} contenteditable>{item.price}.00</span></td>
                      <td style={{ borderWidth: "1px", padding: "0.5em", position: "relative", textAlign: "center", borderRadius: "0.25em", borderStyle: "solid", borderColor: "#DDD" }}><span style={{ borderRadius: "0.25em", minWidth: "1em", outline: "0", display: "inline-block" }} contenteditable>{item.quantity}</span></td>
                      <td style={{ borderWidth: "1px", padding: "0.5em", position: "relative", textAlign: "right", borderRadius: "0.25em", borderStyle: "solid", borderColor: "#DDD" }}><span data-prefix>Rs </span><span>{item.subtotal}.00</span></td>
                      <td style={{ borderWidth: "1px", padding: "0.5em", position: "relative", textAlign: "right", borderRadius: "0.25em", borderStyle: "solid", borderColor: "#DDD" }}><span data-prefix>Rs </span><span>{item.gstamount}.00</span></td>
                      <td style={{ borderWidth: "1px", padding: "0.5em", position: "relative", textAlign: "right", borderRadius: "0.25em", borderStyle: "solid", borderColor: "#DDD" }}><span data-prefix>Rs </span><span>{item.total}.00</span></td>
                    </tr>
                  )
                })}
              </tbody>
            </table>

            <table className="balance" style={{ margin: "0 0 3em", float: "right", width: "36%", fontSize: "75%", tableLayout: "fixed", width: "100%", borderCollapse: "separate", borderSpacing: "2px", float: "right", width: "36%" }}>
              <tr>
                <th style={{ borderWidth: "1px", padding: "0.5em", position: "relative", textAlign: "left", borderRadius: "0.25em", borderStyle: "solid", background: "#EEE", borderColor: "#BBB" }}  ><span style={{ borderRadius: "0.25em", minWidth: "1em", outline: "0", display: "inline-block" }} contenteditable>Sub total</span></th>
                <td style={{ borderWidth: "1px", padding: "0.5em", position: "relative", textAlign: "right", borderRadius: "0.25em", borderStyle: "solid", borderColor: "#DDD" }}><span data-prefix>Rs </span><span>{sale.subtotal}.00</span></td>
              </tr>
              <tr>
                <th style={{ borderWidth: "1px", padding: "0.5em", position: "relative", textAlign: "left", borderRadius: "0.25em", borderStyle: "solid", background: "#EEE", borderColor: "#BBB" }}  ><span style={{ borderRadius: "0.25em", minWidth: "1em", outline: "0", display: "inline-block" }} contenteditable>GST total</span></th>
                <td style={{ borderWidth: "1px", padding: "0.5em", position: "relative", textAlign: "right", borderRadius: "0.25em", borderStyle: "solid", borderColor: "#DDD" }}><span data-prefix>Rs </span><span style={{ borderRadius: "0.25em", minWidth: "1em", outline: "0", display: "inline-block" }} contenteditable>{sale.gstamount}.00</span></td>
              </tr>
              <tr>
                <th style={{ borderWidth: "1px", padding: "0.5em", position: "relative", textAlign: "left", borderRadius: "0.25em", borderStyle: "solid", background: "#EEE", borderColor: "#BBB" }}  ><span style={{ borderRadius: "0.25em", minWidth: "1em", outline: "0", display: "inline-block" }} contenteditable>Bill amount</span></th>
                <td style={{ borderWidth: "1px", padding: "0.5em", position: "relative", textAlign: "right", borderRadius: "0.25em", borderStyle: "solid", borderColor: "#DDD" }}><span data-prefix>Rs </span><span>{sale.billamount}.00  </span></td>
              </tr>
            </table>
          </article>
          <div className='hideOnPrint' style={{position: "absolute", bottom: "0", right: "0", margin: "50px 50px", display: window.matchMedia('print').matches ? 'none' : 'block' }}>
            <button onClick={(e) => { printInvoice(e) }} style={{ backgroundColor: "#318CE7", border: "none", color: "white", padding: "10px 20px", borderRadius: "10px", textAlign: "center", display: "block", fontSize: "16px" }}>Print</button>
          </div>
        </div>


        <aside >
          <h1><span contenteditable>Additional Notes</span></h1>
          <div contenteditable>
            <p>A finance charge of 1.5% will be made on unpaid balances after 30 days.</p>
          </div>
        </aside>


      </div>

    </div>



  )
}

export default Print;